import type { Brand } from '@/domainLogic/index.ts';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { MODAL_SIZES } from '@/app/components/search/components/Modal/OpenXModal/types.ts';
import ModalHeader from '@/app/components/search/components/Modal/LayoutElements/ModalHeader';
import OpenXModal from '@/app/components/search/components/Modal/OpenXModal';
import { useChangeTransportDetailsModal } from '@/app/components/hotel-detail/changeTransport/ChangeTransportDetailsModalProvider';
import { useIsDesktop } from '@/app/components/search/utils/useSsrMedia';
import { useTranslation } from '@/app/components/translations/Translation';
import { useUrlSearchParams } from '@/app/components/hotel-detail/UrlSearchParamsProvider';
import { EvoTransportJourneyDetails } from './EvoTransportJourneyDetails';

export function EvoChangeTransportDetailsModal() {
  const { isOpen, selectedTransport, closeModal } = useChangeTransportDetailsModal();
  const { localization } = usePageWrapperData();
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();
  const { isTrain } = useUrlSearchParams();

  const title = isTrain
    ? t('vacation.common.trains.trainandbaggagedetails')
    : t('vacation.common.flights.flightandbaggagedetails');

  return (
    <OpenXModal
      isOpen={isOpen || false}
      isMobile={!isDesktop}
      onClose={closeModal}
      fullScreen={false}
      brand={localization.brand as Brand}
      disableBrowserHistoryNavigation={true}
      id="flight-details-modal"
      size={MODAL_SIZES.L_EVO}
      aria-label={title}
      bodyBackgroundColor="backgroundLayer02"
      scrollShadows={localization?.configValuesApp?.evolutionEnabled}
      header={{
        sticky: true,
        element: <ModalHeader handleClose={closeModal}>{title}</ModalHeader>,
      }}
    >
      {selectedTransport && (
        <EvoTransportJourneyDetails
          outbound={selectedTransport.outbound}
          inbound={selectedTransport.inbound}
          co2Footprint={selectedTransport.co2Footprint}
          numberOfBaggagePiecesIncluded={selectedTransport.numberOfBaggagePiecesIncluded}
        />
      )}
    </OpenXModal>
  );
}
